module.exports = __webpack_public_path__ + "img/mobile-education.53c36fef.png";